import { useSandpack } from "./useSandpack";
export const useSandpackNavigation = (clientId) => {
    const { dispatch } = useSandpack();
    return {
        refresh: () => dispatch({ type: "refresh" }, clientId),
        back: () => dispatch({ type: "urlback" }, clientId),
        forward: () => dispatch({ type: "urlforward" }, clientId),
    };
};
//# sourceMappingURL=useSandpackNavigation.js.map